var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vv-box',{attrs:{"title":_vm.title}},_vm._l((_vm.tips),function(tip){return _c('vv-single-tip',{key:tip.id,attrs:{"label":tip}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }